<template>
  <div class="push-logs">
    <!-- 统计卡片 -->
    <el-row :gutter="20" class="stat-row">
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-value">{{ stats.total || 0 }}</div>
          <div class="stat-label">{{ $t('autoPush.statTotal') }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-value" style="color: #67C23A;">{{ stats.success || 0 }}</div>
          <div class="stat-label">{{ $t('autoPush.statSuccess') }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-value" style="color: #F56C6C;">{{ stats.failed || 0 }}</div>
          <div class="stat-label">{{ $t('autoPush.statFailed') }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-value" style="color: #409EFF;">{{ stats.readRate || '0%' }}</div>
          <div class="stat-label">{{ $t('autoPush.statReadRate') }}</div>
        </el-card>
      </el-col>
    </el-row>

    <el-card>
      <div slot="header" class="card-header">
        <span>{{ $t('autoPush.logsTitle') }}</span>
        <el-button size="small" @click="$router.push('/auto-push')">{{ $t('autoPush.back') }}</el-button>
      </div>

      <!-- 筛选表单 -->
      <el-form inline class="search-form">
        <el-form-item :label="$t('autoPush.filterName')">
          <el-input v-model="search.taskName" :placeholder="$t('autoPush.filterNamePh')" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('autoPush.filterUserId')">
          <el-input v-model="search.userId" :placeholder="$t('autoPush.filterUserId')" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('autoPush.filterNotificationType')">
          <el-select v-model="search.notificationType" :placeholder="$t('autoPush.filterNotificationType')" clearable style="width: 140px;" @change="handleSearch">
            <el-option :label="$t('autoPush.filterNotificationTypeAll')" value=""></el-option>
            <el-option :label="$t('autoPush.filterNotificationTypePush')" value="push"></el-option>
            <el-option :label="$t('autoPush.filterNotificationTypeReminder')" value="reminder"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('autoPush.filterPushMode')">
          <el-select v-model="search.pushMode" :placeholder="$t('autoPush.filterPushMode')" clearable style="width: 150px;" @change="handleSearch">
            <el-option :label="$t('autoPush.filterPushModeAll')" value=""></el-option>
            <el-option :label="$t('autoPush.filterPushModePeriodic')" value="periodic"></el-option>
            <el-option :label="$t('autoPush.filterPushModeEnrolledWeek')" value="enrolledWeek"></el-option>
            <el-option :label="$t('autoPush.filterPushModeEvent')" value="event"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('autoPush.filterDateRange')">
          <el-date-picker
            v-model="search.dateRange"
            type="daterange"
            :range-separator="$t('autoPush.rangeSepLog')"
            :start-placeholder="$t('autoPush.rangeStartLog')"
            :end-placeholder="$t('autoPush.rangeEndLog')"
            value-format="yyyy-MM-dd"
            clearable
            @change="handleSearch"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetSearch">{{ $t('autoPush.reset') }}</el-button>
        </el-form-item>
      </el-form>

      <!-- 日志列表 -->
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" :label="$t('autoPush.logColId')" width="90"></el-table-column>
        <el-table-column :label="$t('autoPush.logColNotificationType')" width="110">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.notificationType === 'reminder' ? 'warning' : 'primary'" effect="plain">
              {{ getNotificationTypeName(scope.row.notificationType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="taskId" :label="$t('autoPush.logColTaskId')" width="80">
          <template slot-scope="scope">
            {{ scope.row.taskId || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="taskName" :label="$t('autoPush.logColTaskName')" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.taskName || $t('autoPush.manualPushLabel') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('autoPush.logColPushMode')" width="120">
          <template slot-scope="scope">
            <el-tag size="mini" :type="getPushModeType(scope.row.pushMode)" effect="plain">
              {{ getPushModeName(scope.row.pushMode) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="userId" :label="$t('autoPush.logColUserId')" width="80"></el-table-column>
        <el-table-column prop="userName" :label="$t('autoPush.logColUserName')" width="120"></el-table-column>
        <el-table-column prop="title" :label="$t('autoPush.logColTitle')" show-overflow-tooltip></el-table-column>
        <!-- 课程内容推送才有内容；提醒通知没有 -->
        <el-table-column v-if="hasContentColumn" :label="$t('autoPush.logColContentTitle')" width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.contentTitle || '-' }}
          </template>
        </el-table-column>
        <!-- 提醒通知才有渠道（email/ios）；课程推送没有 -->
        <el-table-column v-if="hasChannelColumn" :label="$t('autoPush.logColChannel')" width="110">
          <template slot-scope="scope">
            {{ scope.row.channel || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('autoPush.logColStatus')" width="90">
          <template slot-scope="scope">
            <el-tag :type="getLogStatusType(scope.row.status)" size="mini">{{ getLogStatusName(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <!-- 语言：课程推送取 push_logs.language，提醒通知取 notification_logs.language
             （历史提醒记录没有该值，后端会回退到用户当前语言）。
             为空时显示「-」——旧写法把空值落进中文分支，会把未知语言误标成中文 -->
        <el-table-column prop="language" :label="$t('autoPush.logColLanguage')" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.language" size="mini" :type="scope.row.language === 'en' ? 'warning' : 'success'">
              {{ scope.row.language === 'en' ? $t('common.langEn') : $t('common.langZh') }}
            </el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="sentAt" :label="$t('autoPush.logColSentAt')" width="170"></el-table-column>
        <el-table-column prop="readAt" :label="$t('autoPush.logColReadAt')" width="170">
          <template slot-scope="scope">
            {{ scope.row.readAt || '-' }}
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="pagination"
        @current-change="handlePageChange"
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { getLogs } from '@/api/autoPush'

export default {
  name: 'AutoPushLogs',
  data() {
    return {
      stats: {},
      list: [],
      loading: false,
      page: 1,
      pageSize: 20,
      total: 0,
      search: {
        taskName: '',
        userId: '',
        notificationType: '',
        pushMode: '',
        dateRange: null
      }
    }
  },
  created() {
    this.loadData()
  },
  watch: {
    'search.taskName'(val, oldVal) {
      if (val !== oldVal) this.debounceSearch()
    },
    'search.userId'(val, oldVal) {
      if (val !== oldVal) this.debounceSearch()
    }
  },
  computed: {
    // 当前列表是否包含课程内容推送记录（有 content_id）
    hasContentColumn() {
      return this.list.some(row => row.notificationType === 'push')
    },
    // 当前列表是否包含提醒通知记录（无 content_id，有 channel）
    hasChannelColumn() {
      return this.list.some(row => row.notificationType === 'reminder')
    }
  },
  methods: {
    // 防抖搜索，避免输入过程中频繁请求
    debounceSearch() {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.handleSearch()
      }, 300)
    },
    // 加载日志数据
    loadData() {
      this.loading = true
      const params = {
        page: this.page,
        pageSize: this.pageSize,
        taskName: this.search.taskName,
        userId: this.search.userId,
        notificationType: this.search.notificationType,
        pushMode: this.search.pushMode
      }
      if (this.search.dateRange && this.search.dateRange.length === 2) {
        params.startDate = this.search.dateRange[0]
        params.endDate = this.search.dateRange[1]
      }
      getLogs(params).then(res => {
        this.list = res.data.list || []
        this.total = res.data.total || 0
        this.stats = res.data.stats || {}
      }).catch(() => {
        this.$message.error(this.$t('autoPush.loadLogsFail'))
      }).finally(() => {
        this.loading = false
      })
    },
    // 搜索
    handleSearch() {
      this.page = 1
      this.loadData()
    },
    // 重置搜索
    resetSearch() {
      this.search = { taskName: '', userId: '', notificationType: '', pushMode: '', dateRange: null }
      this.page = 1
      // 强制 dateRange 回到 null，避免 el-date-picker 残留旧默认值
      this.$nextTick(() => {
        this.loadData()
      })
    },
    // 日志状态标签类型
    getLogStatusType(status) {
      const map = { sent: 'success', read: 'primary', failed: 'danger', pending: 'warning', skipped: 'info' }
      return map[status] || 'info'
    },
    // 日志状态名称
    getLogStatusName(status) {
      const map = {
        sent: this.$t('autoPush.logStatusSent'),
        read: this.$t('autoPush.logStatusRead'),
        failed: this.$t('autoPush.logStatusFailed'),
        pending: this.$t('autoPush.logStatusPending'),
        skipped: this.$t('autoPush.logStatusSkipped')
      }
      return map[status] || status
    },
    // 通知类型名称
    getNotificationTypeName(type) {
      const map = {
        push: this.$t('autoPush.notifTypePush'),
        reminder: this.$t('autoPush.notifTypeReminder')
      }
      return map[type] || (type || '-')
    },
    // 推送模式名称
    getPushModeName(mode) {
      const map = {
        periodic: this.$t('autoPush.filterPushModePeriodic'),
        enrolledWeek: this.$t('autoPush.filterPushModeEnrolledWeek'),
        event: this.$t('autoPush.filterPushModeEvent')
      }
      return map[mode] || (mode || '-')
    },
    // 推送模式标签类型（与任务列表 index.vue 保持一致）
    getPushModeType(mode) {
      const map = { periodic: 'primary', enrolledWeek: 'warning', event: 'info' }
      return map[mode] || 'info'
    },
    // 分页
    handlePageChange(page) {
      this.page = page
      this.loadData()
    }
  }
}
</script>

<style scoped>
.stat-row {
  margin-bottom: 20px;
}
.stat-card {
  text-align: center;
  padding: 10px 0;
}
.stat-value {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
}
.stat-label {
  font-size: 14px;
  color: #909399;
  margin-top: 5px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
}
.search-form {
  margin-bottom: 15px;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
